import QuotationJournalContext from '@contexts/QuotationContext/QuotationJournalContext';
import { useContext } from 'react';

function useQuotationJournal() {
  return useContext(QuotationJournalContext);
}

export default useQuotationJournal;
